import { useState } from 'react';
import {
  Box,
  IconButton,
  MdVisibility,
  MdVisibilityOff,
  TypographyProps,
} from '@bymason-private/legacy-pattern-components';

export type SensitiveTextProps = Omit<TypographyProps, 'select'> & {
  errorText?: string;
  readOnlyDisabled?: boolean;
  readOnly?: boolean;
};

export const SensitiveText = function (props: SensitiveTextProps) {
  const { children } = props;
  const [showInfo, setShowInfo] = useState(false);

  const handleVisibilityToggle = () => {
    setShowInfo(!showInfo);
  };

  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };

  return (
    <Box sx={{ display: 'flex', mt: 0.3 }}>
      {showInfo ? (
        <Box>{children}</Box>
      ) : (
        <Box>{'*'.repeat(typeof children === 'string' ? String(children).length : 6)}</Box>
      )}
      {
        <IconButton
          color='secondary'
          onClick={handleVisibilityToggle}
          onMouseDown={handleMouseDownPassword}
          sx={{ my: -0.8, py: -3 }}
        >
          {showInfo ? <MdVisibilityOff /> : <MdVisibility />}
        </IconButton>
      }
    </Box>
  );
};
